export var SelectedTriggerReason;
(function (SelectedTriggerReason) {
    SelectedTriggerReason[SelectedTriggerReason["selected"] = 0] = "selected";
    SelectedTriggerReason[SelectedTriggerReason["mouseover"] = 1] = "mouseover";
    SelectedTriggerReason[SelectedTriggerReason["mouseout"] = 2] = "mouseout";
})(SelectedTriggerReason || (SelectedTriggerReason = {}));
